import { Globe, Send, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer({ scrollToSection, onOpenLegal, onOpenPrivacy, onOpenTransparency, onOpenCookies }) {
  return (
    <footer className="footer" data-testid="footer-section">
      <div className="container-custom">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="IA Sanitaria @tecnoabogado" className="h-16 w-auto" />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Servicio desarrollado por especialistas en derecho tecnológico, protección de datos e IA aplicada al sector legal y sanitario.
            </p>
            <p className="text-white font-semibold mb-6">Enfoque 100% práctico para clínicas privadas.</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400"><Globe className="w-4 h-4 text-blue-400" />www.iasanitaria.es</li>
              <li className="flex items-center gap-3">
                <Send className="w-4 h-4 text-blue-400" />
                <button onClick={() => scrollToSection('diagnostico')} className="footer-link hover:text-blue-400 transition-colors">Solicitar diagnóstico</button>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold mb-4">Información Legal</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={onOpenLegal} className="footer-link hover:text-blue-400 transition-colors" data-testid="footer-aviso-legal">
                  Aviso Legal
                </button>
              </li>
              <li>
                <button onClick={onOpenPrivacy} className="footer-link hover:text-blue-400 transition-colors" data-testid="footer-privacidad">
                  Política de Privacidad
                </button>
              </li>
              <li>
                <button onClick={onOpenTransparency} className="footer-link hover:text-blue-400 transition-colors" data-testid="footer-transparencia-ia">
                  Transparencia IA (EU AI Act)
                </button>
              </li>
              <li>
                <button onClick={onOpenCookies} className="footer-link hover:text-blue-400 transition-colors" data-testid="footer-cookies">
                  Política de Cookies
                </button>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 mt-8">Marco normativo</h4>
            <p className="text-gray-500 text-sm leading-relaxed">
              RGPD · LOPDGDD · AI Act (Reglamento UE 2024/1689) · Ley 41/2002 de autonomía del paciente.
            </p>
          </div>
          <div>
            <h4 className="text-white font-bold mb-4">Aviso Legal</h4>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              La información de esta página tiene carácter informativo. La cumplimentación del formulario no constituye por sí misma asesoramiento jurídico.
            </p>
            <h4 className="text-white font-bold mb-4">Responsable</h4>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              José Luis Vilaplana (@tecnoabogado)<br />
              info@tecnoabogado.com
            </p>
            <p className="text-gray-600 text-sm mt-8">© 2026 IA Sanitaria · Todos los derechos reservados.</p>
            <Link to="/admin/login" className="inline-flex items-center gap-1.5 text-gray-700 hover:text-gray-500 text-xs mt-3 transition-colors" data-testid="footer-admin-link">
              <Lock className="w-3 h-3" /> Administración
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
